import React, { Component } from 'react';

class TransportsComponent extends Component {
    render() {
        const { openTransporte, writeAccess, searchDocuments, openTransportResume } = this.props;
        return (
            <div className="d-flex flex-wrap align-items-end gap-3 mb-3">
                <div className="form-group d-flex align-items-center mb-2 mr-3" style={{ minWidth: 240 }}>
                    {writeAccess && <button className="btn btn-outline-secondary btn-timbra-one mr-sm-3 btnNuevo"
                        onClick={openTransporte} style={{ width: 260, borderColor: "#A7A6A5", height: 40 }}>
                        <i className="fas fa-plus mr-1"></i><i className="fas fa-truck mr-1"></i>
                            <span className="d-none d-xxl-inline"> Dar de Alta Transporte</span>
                            <span className="d-inline d-xxl-none"> Alta Transporte</span>
                        </button>
                    }
                </div>
                <div className="form-group d-flex align-items-center mb-2 mr-3" style={{ minWidth: 240 }}>
                    <button className="btn btn-outline-secondary btn-timbra-one mr-sm-3 btnNuevo"
                        onClick={openTransportResume} style={{ width: 260, borderColor: "#A7A6A5", height: 40 }}>
                        <i className="fas fa-ellipsis-v mr-1"></i><i className="fas fa-truck mr-1"></i>
                        <span className="d-none d-xxl-inline"> Resumen Transportes</span>
                        <span className="d-inline d-xxl-none"> Resu. Transpte</span>
                    </button>
                </div>
                <div className="form-group d-flex align-items-center mb-2 mr-3" style={{ minWidth: 240 }}>
                    <button className="btn btn-active" data-toggle="tooltip" data-placement="top"
                        title={'Buscar'}
                        onClick={searchDocuments}>
                        <i className="fas fa-search"></i>
                    </button>
                </div>

            </div>
        );
    }
}

export default TransportsComponent;
